import WebFont from 'webfontloader';
import { createGlobalStyle } from 'styled-components';
import { dictionary as CarvanaDesignTokens } from '@carvana/helios-styles/style-dictionary';

import { focusBoxShadow, innerAlignBorder, ui } from './common';
import { isLocalHost } from 'utils/url';

// Load Fonts into the project
WebFont.load({
  google: {
    families: ['Inter:400,500,600'],
  },
});

export const themeVariables = {
  ...CarvanaDesignTokens,
  ...ui,
  innerAlignBorder,
  focusBoxShadow,
};

if (isLocalHost()) {
  console.log('%cChatUI ThemeVariables:\n', 'color: #bada55', themeVariables);
}

// This is the type definition for our custom theme object
export type ThemeType = typeof themeVariables;

export const GlobalStyles = createGlobalStyle`

  body {
    margin: ${themeVariables.spacing['3Xl']};
    padding: 0;
    background: ${themeVariables.background.mutedStrong};
    font-family: ${themeVariables.fontFamily.inter}, Arial, Helvetica, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    textarea {
      font-family: ${themeVariables.fontFamily.inter}, Arial, Helvetica, sans-serif!important; // otherwise gets overridden by Brandon Font on deployed environments
    }
  }
`;
